import React from 'react';
import store from '../store';
import { RESET_CITY,FILE_IMAGES,typeList,showTimeList,LBFormulaList,answerTimeList,qCountList,maxNumberList,digitsList,YesNoList,CompTypeList } from '../config/static';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogSet from './DialogSet';
import DialogCompetitor from './DialogCompetitor';
import DialogCompResult from './DialogCompResult';
import DialogActions  from '@material-ui/core/DialogActions';
import DialogContent  from '@material-ui/core/DialogContent';
import DialogTitle  from '@material-ui/core/DialogTitle';
import ReactPlayer from "react-player";
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import LocationOnIcon from '@material-ui/icons//LocationOn';
import EditIcon from '@material-ui/icons//Edit';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import Typography from '@material-ui/core/Typography';
import firebase from "firebase/app";
import "firebase/firestore";
import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon from '@material-ui/icons/Delete';
import CloseIcon from '@material-ui/icons/Close';
import Divider from '@material-ui/core/Divider';
import ImageIcon from '@material-ui/icons/Image';
import AllInboxIcon from '@material-ui/icons/AllInbox';
import Dropzone from "react-dropzone";
import { NotificationManager} from 'react-notifications';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import Chip from '@material-ui/core/Chip';

import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';

import _ from 'lodash'
const styles = theme => ({
  container: {
    flexGrow: 1,
    position: 'relative',
    marginRight: 'auto',
    marginLeft: 'auto',
    width: '90%',
    maxWidth: 1024
  },
  textField: {
    minWidth: 200
  },
  input: {
    display: 'none',
  },group_list:{
    border:"1px solid gray",
    display:'flex',
    flexDirection:'column'
  },
  group_list_item:{
    textAlign:'center',
    border:"1px solid gray",
    padding:5,
    display:'flex',
    flexDirection:'column',
    justifyContent:'center',
    alignItems:'center'
  }
  ,
  group_list_input:{
    textAlign:'center',
    border:"none",
    background:'transparent',
    width: '100%',
    height: '100%',
  },
});
const MarathonSetting = [
  {name:"Flashcard",showTime:6,answerTime:6,digits:2,percent:70,qCount:20,changeTime:7},
  {name:"Basic",showTime:6,answerTime:6,digits:2,percent:70,qCount:20,changeTime:7},
  {name:"LB+",showTime:6,answerTime:6,digits:2,percent:70,qCount:20,changeTime:7},
  {name:"LB-",showTime:6,answerTime:6,digits:2,percent:70,qCount:20,changeTime:7},
  {name:"BB+",showTime:6,answerTime:6,digits:2,percent:70,qCount:20,changeTime:7},
  {name:"BB-",showTime:6,answerTime:6,digits:2,percent:70,qCount:20,changeTime:7},
  {name:"+/-",showTime:6,answerTime:6,digits:2,percent:70,qCount:20,changeTime:7},
]
function searchLabel(array,value)
{
  let rel='';
  let index = array.findIndex(a=>a.value==value);
  if(index>-1)
  {
    rel = array[index].label;
  }
  return rel;
}
var _this;
const defaultSetting = {type:[],
times:1,
rows:3,
showTime:6,
answerTime:10,
qCount:10,
maxNumber:10,
digits:1,
digits1:1,
digits2:1,
point:0,
percent:80,
displaySetting:0,
displayShow:0,
lessThan0:0,
largerThan:0,
roundNumber:0,
isReversed:0,
dr1:0,
dr2:0,
dba:1,
ssp:0,
}

class CreateDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      item: _.cloneDeep(props.item),
      open: false,
      curRoundIndex:0,
      curLevelIndex:0,

    }
    _this = this;
  }
  componentDidMount(props)
  {

  }





  handleChange = name => event => {
    event.preventDefault();
    const item = _this.state.item;
    if(name=="level")
    item[name] = event.target.value||1;
    else
    item[name] = event.target.value;

    _this.setState({ item });
  }




async  CreateItem  (data) {

    const item = data;

    //var check = window.confirm("Do you want to add category?");
    var _this=this;

          var docRef = firebase.firestore().collection("comps").doc();

            docRef.set(item)
              .then(function () {
                item.id = docRef.id;
              //  item.order = item.order?parseInt(item.order):0;
                console.log(item);
                  //store.dispatch({ type: 'CREATE_DISTRICT', item });
                NotificationManager.success("Success!");
                _this.forceUpdate();
              //  _this.setState(RESET_CITY);
                //_this.props.onClose();
              })
              .catch(function (error) {
                console.error(error);
              });






  }

  async SaveItem  (data)  {
    //event.preventDefault();
    const item = data;

    var _this=this;

      const id = item.id;

      firebase.firestore().collection("comps").doc(id).update(item)
        .then(function () {
          item.id = id;
          //item.order = item.order?parseInt(item.order):0;
          //let index = store.getState().CITIES.findIndex(e => e.id === id);
          //store.dispatch({ type: 'UPDATE_DISTRICT', item, index });
          NotificationManager.success("Success!");
        //  _this.setState(RESET_CITY);
          _this.forceUpdate();
        })
        .catch(function (error) {
          console.error(error);
        });

  }

  handleClose = () => event => {
    event.preventDefault();
    //this.setState(RESET_CITY);
    this.props.onClose();
  };
  handleChangeWeek = event=>{
    event.preventDefault();

    this.setState({curWeekIndex:event.target.value,curDayIndex:null})
  }

  onItemChange = (value,item,key)=>{
    item[key]=value;
    this.forceUpdate();
  }
  addRoundPart = (curRound)=>{
    if(!curRound.parts)
    curRound.parts = [];
    curRound.parts.push({type:"see",set:1,time:30,sets:[]});
    this.forceUpdate();
  }
  removeRoundPart = (curRound,index)=>{
    curRound.parts.splice(index,1);
    this.forceUpdate();
  }
  onBGLinkChange = (value,key)=>{

      if((!value||value.trim().length==0))
      value="";
      else {
        let t = value.split("file/d/");

        if(t.length>1)
        {
          t = t[1].split("/");
          value="https://drive.google.com/uc?export=view&id="+t[0];
          console.log(value)
        }
      }
      const item = _this.state.item;
      item[key] = value;
        _this.setState({ item });
    //_this.setState({rules_audio:value});

  }
  onLinkChange = (value)=>{

      if((!value||value.trim().length==0))
      value="";
      else {
        let t = value.split("file/d/");

        if(t.length>1)
        {
          t = t[1].split("/");
          value="https://drive.google.com/uc?export=view&id="+t[0];
          console.log(value)
        }
      }
      const item = _this.state.item;
      item['rules_audio'] = value;
        _this.setState({ item });
    //_this.setState({rules_audio:value});

  }
  onRoundLinkChange = (value,round)=>{

      if((!value||value.trim().length==0))
      value="";
      else {
        let t = value.split("file/d/");

        if(t.length>1)
        {
          t = t[1].split("/");
          value="https://drive.google.com/uc?export=view&id="+t[0];
          console.log(value)
        }
      }
      round['rules_audio'] = value;
        _this.forceUpdate();
    //_this.setState({rules_audio:value});

  }

  render() {
    const { classes, onClose, fullScreen, onChange, ...other } = this.props;
    const { item,curRoundIndex,curLevelIndex } = this.state;
    if(!item.levels)
    {
      item.levels = [];
    }
    if(item.levels.length>item.level)
    {
      item.levels = item.levels.splice(0,item.level);
    }
    for(let i=0;i<item.level;i++)
    {

      if(!item.levels[i])
      {
        item.levels[i] = {name:"Cấp độ "+(i+1),round:3,level_id:"capdo"+(i+1),age:5,toage:8};
      }
    }

    let curLevel = item.levels[curLevelIndex];
    let no_rounds = [];
    if(!curLevel.rounds)
    {
      curLevel.rounds = [];
    }
    if(curLevel.rounds.length>curLevel.round)
    {
      curLevel.rounds = curLevel.rounds.splice(0,curLevel.round);
    }
    for(let i=0;i<curLevel.round;i++)
    {
      no_rounds.push(i);
      if(!curLevel.rounds[i])
      {
        curLevel.rounds[i] = {name:(i+1).toString(),startTime:"",endTime:"",time:30,pass:100,showRankLimit:100,compare_round:"-1"};
      }
    }
    let curRound = curLevel.rounds[curRoundIndex];




    const isEnabled = !item ? false : item.name && item.level && item.comp_id&& item.startDate&& item.endDate;
    return (<div>
      {!item ? '' :
        <Dialog onClose={this.props.onClose} open={false} fullScreen={fullScreen} {...other}>
          <DialogTitle>
            <Grid justify="flex-start" direction="row" container>
              <Grid item style={{ marginRight: 8 }}><AllInboxIcon /></Grid>
              <Grid item>
                <Typography variant="title" className={classes.title}>Competition</Typography>
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent className={classes.container}>
            <Typography variant="body2" color="primary" style={{ marginBottom: 10 }}></Typography>
            <Divider style={{ marginBottom: 5 }} />
            <Grid container>
              <Grid item xs style={{ margin: 5 }}>
                <TextField
                  value={item.comp_id}
                  onChange={this.handleChange('comp_id')}
                  label="Mã cuộc thi"
                  fullWidth
                  required
                  placeholder="THI01"
                  type="text"
                  margin="normal"
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
              <Grid item xs style={{ margin: 5 }}>
                <TextField
                  value={item.name}
                  onChange={this.handleChange('name')}
                  label="Tên"
                  rows={2}
                  multiline={true}
                  fullWidth
                  required
                  placeholder=""
                  type="text"
                  margin="normal"
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
              
              <Grid item xs style={{ margin: 5 }}>
                <TextField
                  value={"https://app.superbrain.edu.vn/competition?id="+item.comp_id}
                  label="Link cuộc thi"
                  fullWidth
                  required
                  placeholder=""
                  type="text"
                  margin="normal"
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
              {false&&<Grid item xs style={{ margin: 5 }}>
                <TextField
                  value={item.round}
                  onChange={this.handleChange('round')}
                  label="Số vòng"
                  fullWidth
                  required
                  placeholder=""
                  type="number"
                  margin="normal"
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>}


            </Grid>
            <Grid container>
              <Grid item xs style={{ margin: 5 }}>
              <TextField
                      value={item.startDate}
                      onChange={this.handleChange('startDate')}
                      label="Ngày bắt đầu đăng ký"
                      required
                      fullWidth
                      placeholder="01/01/2021"
                      type="date"
                      margin="normal"
                      className={classes.textField}
                      InputLabelProps={{
                          shrink: true,
                      }}
                  />
              </Grid>
              <Grid item xs style={{ margin: 5 }}>
              <TextField
                      value={item.endDate}
                      onChange={this.handleChange('endDate')}
                      label="Ngày kết thúc đăng ký"
                      required
                      fullWidth
                      placeholder="01/01/2021"
                      type="date"
                      margin="normal"
                      className={classes.textField}
                      InputLabelProps={{
                          shrink: true,
                      }}
                  />
              </Grid>
            </Grid>
            <Grid container>
            <Grid item xs style={{ margin: 5 }}>
                <TextField
                  value={item.level}
                  onChange={this.handleChange('level')}
                  label="Số cấp độ"
                  fullWidth
                  required
                  placeholder=""
                  type="number"
                  margin="normal"
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
              <Grid item xs style={{ margin: 5 }}>
                <TextField
                  value={item.showRankTime}
                  onChange={this.handleChange('showRankTime')}
                  label="TG hiện BXH sau mỗi vòng(giây)"
                  fullWidth
                  required
                  placeholder=""
                  type="number"
                  margin="normal"
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>

              <Divider style={{height:2,width:"100%",marginTop:10,marginBottom:10}} />
              <Grid item xs={12} style={{ margin: 5 }}>
                <TextField
                  value={item.bg_main}
                  onChange={(e)=>this.onBGLinkChange(e.target.value,'bg_main')}
                  label="Link hình nền Chính + Đăng Nhập"
                  fullWidth
                  
                  placeholder=""
                  type="text"
                  margin="normal"
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
              <Grid item xs={5} style={{ margin: 5 }}>
                <TextField
                  value={item.bg_nq}
                  onChange={(e)=>this.onBGLinkChange(e.target.value,'bg_nq')}
                  label="Link hình nền Nội Quy"
                  fullWidth

                  placeholder=""
                  type="text"
                  margin="normal"
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
              <Grid item xs={5} style={{ margin: 5 }}>
                <TextField
                  value={item.bg_wait}
                  onChange={(e)=>this.onBGLinkChange(e.target.value,'bg_wait')}
                  label="Link hình nền Chờ"
                  fullWidth
                  
                  placeholder=""
                  type="text"
                  margin="normal"
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
              <Grid item xs={5} style={{ margin: 5 }}>
                <TextField
                  value={item.bg_rank}
                  onChange={(e)=>this.onBGLinkChange(e.target.value,'bg_rank')}
                  label="Link hình nền Xếp hạng"
                  fullWidth

                  placeholder=""
                  type="text"
                  margin="normal"
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
              <Grid item xs={5} style={{ margin: 5 }}>
                <TextField
                  value={item.bg_see}
                  onChange={(e)=>this.onBGLinkChange(e.target.value,'bg_see')}
                  label="Link hình nền Nhìn tính"
                  fullWidth

                  placeholder=""
                  type="text"
                  margin="normal"
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
              <Grid item xs={5} style={{ margin: 5 }}>
                <TextField
                  value={item.bg_listen}
                  onChange={(e)=>this.onBGLinkChange(e.target.value,'bg_listen')}
                  label="Link hình nền Nghe tính"
                  fullWidth

                  placeholder=""
                  type="text"
                  margin="normal"
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>

              <Grid item xs={5} style={{ margin: 5 }}>
                <TextField
                  value={item.bg_online}
                  onChange={(e)=>this.onBGLinkChange(e.target.value,'bg_online')}
                  label="Link hình nền Online"
                  fullWidth

                  placeholder=""
                  type="text"
                  margin="normal"
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
              <Divider  style={{height:2,width:"100%",marginTop:10,marginBottom:10}} />
              <Grid item xs={12} style={{ margin: 5 }}>
                <TextField
                  value={item.rules}
                  onChange={this.handleChange('rules')}
                  label="Nội quy"
                  fullWidth
                  required
                  rows={4}
                  multiline={true}
                  placeholder=""
                  type="text"
                  margin="normal"
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
                <Grid item xs={12} style={{ margin: 5 }}>
                  <TextField
                    value={item.rules_audio}
                    onChange={(e)=>this.onLinkChange(e.target.value)}
                    label="Link âm thanh Nội quy"
                    fullWidth
                    required

                    placeholder=""
                    type="text"
                    margin="normal"
                    className={classes.textField}
                    InputLabelProps={{
                      shrink: true
                    }}
                  />

              </Grid>
              {item.id&&<Grid item xs={12}>
                <Button onClick={()=>this.setState({showCompView:item})} variant="contained" color="secondary" size="medium">
                        Danh sách thí sinh
                    </Button>
                </Grid>}
                {item.id&&<Grid item xs={12}>
                  <Button onClick={()=>this.setState({showResultView:item})} variant="contained" color="secondary" size="medium">
                          Kết quả cuộc thi
                      </Button>
                  </Grid>}
            </Grid>
            <Divider color="primary" style={{marginTop:10,marginBottom:10}} />
              <Grid container>
                {item.levels.map((i, index) => {
                  let current = curLevelIndex!=null?index==curLevelIndex:false;
                  //console.log(current,i,curRoundIndex);
                  let haveData = item.levels[curLevelIndex]?true:false;
                  return (<Grid  key={index} item style={{width:100,height:100,marginLeft:10,marginBottom:10}} >
                    <Button onClick={e=>this.setState({curLevelIndex:index})} style={{width:100,height:100,backgroundColor:current?'#1B5E20':'grey',color:'white'}} size="large">
                      {i.name}
                  </Button>
                </Grid>)})}
              </Grid>

              <Grid container>
                <Grid item xs style={{ margin: 5 }}>
                  <TextField
                    value={curLevel.name}
                    onChange={(e)=>{
                      curLevel.name = e.target.value;
                      _this.forceUpdate();
                    }}
                    label="Tên cấp độ"
                    fullWidth
                    required
                    placeholder=""
                    type="text"
                    margin="normal"
                    className={classes.textField}
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </Grid>
                <Grid item xs style={{ margin: 5 }}>
                  <TextField
                    value={curLevel.round}
                    onChange={(e)=>{
                      
                      curLevel.round = e.target.value||1;
                      
                      _this.forceUpdate();
                    }}
                    label="Số vòng"
                    fullWidth
                    required
                    placeholder=""
                    type="number"
                    margin="normal"
                    className={classes.textField}
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </Grid>
                </Grid>
                <Grid container>
                <Grid item xs style={{ margin: 5 }}>
                  <TextField
                    value={curLevel.age}
                    onChange={(e)=>{
                      curLevel.age = e.target.value;
                      _this.forceUpdate();
                    }}
                    label="Từ tuổi"
                    fullWidth
                    required
                    placeholder=""
                    type="number"
                    margin="normal"
                    className={classes.textField}
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </Grid>
                <Grid item xs style={{ margin: 5 }}>
                  <TextField
                    value={curLevel.toage}
                    onChange={(e)=>{
                      curLevel.toage = e.target.value;
                      _this.forceUpdate();
                    }}
                    label="Đến tuổi"
                    fullWidth
                    required
                    placeholder=""
                    type="number"
                    margin="normal"
                    className={classes.textField}
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </Grid>




              </Grid>
            <Divider style={{marginTop:10,marginBottom:10}} />
              <Grid container>
                {no_rounds.map((i, index) => {
                  let current = curRoundIndex!=null?i==curRoundIndex:false;
                  //console.log(current,i,curRoundIndex);
                  let haveData = curLevel.rounds[curRoundIndex]?true:false;
                  let r = curLevel.rounds[index];
                  return (<Grid  key={i} item style={{width:100,height:100,marginLeft:10,marginBottom:10}} >
                    <Button onClick={e=>this.setState({curRoundIndex:i})} style={{width:100,height:100,backgroundColor:current?'#1B5E20':'grey',color:'white'}} size="large">
                      Vòng<br/>{r.name||(i+1)}
                  </Button>
                </Grid>)})}
              </Grid>
              <Grid container>
                <Grid item xs style={{ margin: 5 }}>
                  <TextField
                    value={curRound.name||""}
                    onChange={(e)=>{
                      curRound.name = e.target.value;
                      _this.forceUpdate();
                    }}
                    label="Tên vòng"
                    fullWidth
                    required
                    placeholder=""
                    type="text"
                    margin="normal"
                    className={classes.textField}
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </Grid>
                <Grid item xs={12} style={{ margin: 5 }}>
                  <TextField
                    value={curRound.rules||""}
                    onChange={(e)=>{
                      curRound.rules = e.target.value;
                      _this.forceUpdate();
                    }}
                    label="Hướng dẫn"
                    fullWidth
                    required
                    rows={4}
                    multiline={true}
                    placeholder=""
                    type="text"
                    margin="normal"
                    className={classes.textField}
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </Grid>
                  <Grid item xs={12} style={{ margin: 5 }}>
                    <TextField
                      value={curRound.rules_audio||""}
                      onChange={(e)=>this.onRoundLinkChange(e.target.value,curRound)}
                      label="Audio hướng dẫn"
                      fullWidth
                      required

                      placeholder=""
                      type="text"
                      margin="normal"
                      className={classes.textField}
                      InputLabelProps={{
                        shrink: true
                      }}
                    />

                </Grid>
                <Grid item xs style={{ margin: 5 }}>
                <TextField
                        value={curRound.startTime}
                        onChange={(e)=>{
                          curRound.startTime = e.target.value;
                          _this.forceUpdate();
                        }}
                        label="Thời gian bắt đầu làm bài"
                        required
                        fullWidth
                        placeholder="01/01/2019"
                        type="datetime-local"
                        margin="normal"
                        className={classes.textField}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
                <Grid item xs style={{ margin: 5 }}>
                  <TextField
                    value={curRound.time}
                    onChange={(e)=>{
                      curRound.time = e.target.value;
                      _this.forceUpdate();
                    }}
                    label="TG nghỉ mỗi phần thi(giây)"
                    fullWidth
                    required
                    placeholder=""
                    type="number"
                    margin="normal"
                    className={classes.textField}
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </Grid>
                <Grid item xs={12} style={{ margin: 5 }}>
                  <TextField
                    value={curRound.showRankLimit||100}
                    onChange={(e)=>{
                      curRound.showRankLimit = e.target.value;
                      _this.forceUpdate();
                    }}
                    label="Số lượng thí sinh hiện trên BXH"
                    fullWidth
                    required
                    placeholder=""
                    type="number"
                    margin="normal"
                    className={classes.textField}
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </Grid>
                <Grid item xs={12} style={{ margin: 5 }}>
                  <TextField
                      value={curRound.compare_round !=undefined?curRound.compare_round:"-1"}
                      onChange={(e)=>{
                        curRound.compare_round = e.target.value;
                        _this.forceUpdate();
                      }}
                      label="So sánh kết quả từ vòng"
                      placeholder=""
                      select
                      margin="normal"
                      InputLabelProps={{
                          shrink: true,
                          style: { color: '#1B5E20',fontSize:'1.2rem' }
                      }}
                      fullWidth


                  >
                  <MenuItem  value={"-1"}>
                Không so sánh
              </MenuItem>
                  {curLevel.rounds.map((t,index)=>{
                    if(curRoundIndex==index)
                    return false;
                    return (<MenuItem key={"Compare"+index} value={index}>
                  Vòng {t.name||(index+1)}
                </MenuItem>)
                  })}
                  </TextField>
                </Grid>
                {curRound.compare_round!=undefined&&curRound.compare_round!="-1"&&<Grid item xs={12} style={{ margin: 5 }}>
                  <TextField
                    value={curRound.pass}
                    onChange={(e)=>{
                      curRound.pass = e.target.value;
                      _this.forceUpdate();
                    }}
                    label={"Số lượng thí sinh lấy từ vòng "+(curLevel.rounds[parseInt(curRound.compare_round)].name||parseInt(curRound.compare_round)+1)}
                    fullWidth
                    required
                    placeholder=""
                    type="number"
                    margin="normal"
                    className={classes.textField}
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </Grid>}

                <Grid item xs={12}>
                  <Button onClick={()=>this.addRoundPart(curRound)} variant="contained" color="primary" size="small">
                          Thêm phần thi
                      </Button>
                  </Grid>

                <Grid item xs={12}>
                  {curRound&&curRound.parts&&<div className={classes.group_list}>
                        <div style={{display:'flex',flexDirection:'row'}}>
                          <div className={classes.group_list_item} style={{width:'15%'}}>STT</div>
                          <div className={classes.group_list_item} style={{width:'30%'}}>Loại</div>
                          <div className={classes.group_list_item} style={{width:'20%'}}>Số set</div>
                          <div className={classes.group_list_item} style={{width:'15%'}}>TG nghỉ mỗi set(giây)</div>
                          <div className={classes.group_list_item} style={{width:'20%'}}></div>
                      </div>
                      {curRound.parts.map((r,index)=>{

                        return <div key={index} style={{display:'flex',flexDirection:'row'}}>
                          <div className={classes.group_list_item} style={{width:'15%'}}>{index+1}</div>
                          <div className={classes.group_list_item} style={{width:'30%'}}>

                              <TextField
                                  value={r.type}
                                  onChange={(e)=>this.onItemChange(e.target.value,r,'type')}
                                  label=""
                                  placeholder=""
                                  select
                                  margin="normal"
                                  InputLabelProps={{
                                      shrink: true,
                                      style: { color: '#1B5E20',fontSize:'1.2rem' }
                                  }}
                                  fullWidth


                              >
                              {CompTypeList.map((t,index)=>{
                                return (<MenuItem key={"LessItem"+index} value={t.value}>
                              {t.label}
                            </MenuItem>)
                              })}
                              </TextField></div>
                            <div className={classes.group_list_item} style={{width:'20%'}}><input className={classes.group_list_input} onChange={(e)=>this.onItemChange(parseInt(e.target.value),r,'set')} type="text" value={r.set}/><br/>
                            <Button onClick={()=>this.setState({showSetView:r})} variant="contained" color="primary" aria-label="add" size="small">Cài đặt
                        </Button></div>
                          <div className={classes.group_list_item} style={{width:'15%'}}><input className={classes.group_list_input} onChange={(e)=>this.onItemChange(parseInt(e.target.value),r,'time')} type="number" value={r.time}/></div>
                          <div className={classes.group_list_item} style={{width:'20%'}}><Button onClick={()=>this.removeRoundPart(curRound,index)} variant="contained" color="error" aria-label="add" size="small">Xoá
                      </Button></div>
                    </div>
                      })}

                    </div>}
                </Grid>

              </Grid>









          </DialogContent>

          <DialogActions style={{ padding: 10 }}>
            <Button onClick={this.handleClose()} size="large">
              <CloseIcon style={{ marginRight: 5 }} />BACK
          </Button>
          {/*!item.id ? '' : <Button onClick={this.DeleteItem(item.id)} size="large" color="primary">
              <DeleteIcon style={{ marginRight: 5 }} /> DELETE </Button>*/}
            {!item.id ? <Button onClick={()=>this.CreateItem(item)} disabled={!isEnabled} size="large" variant="contained" color="secondary">
              <SaveIcon style={{ marginRight: 5 }} />Create
          </Button> :
              <Button onClick={()=>this.SaveItem(item)} disabled={!isEnabled} size="large" variant="contained" color="secondary">
                <SaveIcon style={{ marginRight: 5 }} />SAVE
        </Button>}
          </DialogActions>
        </Dialog>

      }
      {this.state.showSetView ?<DialogSet
          part={this.state.showSetView}
          fullScreen={true}
          open={this.state.showSetView!=null}
          onClose={()=>this.setState({ showSetView: false })}
      />:false}
      {this.state.showCompView ?<DialogCompetitor
          item={this.state.showCompView}
          fullScreen={true}
          open={this.state.showCompView!=null}
          onClose={()=>this.setState({ showCompView: false })}
      />:false}
      {this.state.showResultView ?<DialogCompResult
          item={this.state.showResultView}
          fullScreen={true}
          open={this.state.showResultView!=null}
          onClose={()=>this.setState({ showResultView: false })}
      />:false}

    </div>);
  }
}

CreateDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func
};

export default withStyles(styles)(CreateDialog);
